import { useState, useEffect } from 'react';
import { seasonsService, SeasonOption } from '../services/seasons';

export const useSeasons = () => {
  const [seasons, setSeasons] = useState<SeasonOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSeasons = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const data = await seasonsService.getAccessibleSeasons();
        setSeasons(data);
      } catch (err) {
        setError('Error fetching seasons');
        console.error('Error in useSeasons:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSeasons();
  }, []);

  return { seasons, loading, error };
};

export const useSeasonsByTournament = (tournamentId: string) => {
  const [seasons, setSeasons] = useState<SeasonOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSeasons = async () => {
      if (!tournamentId) {
        setSeasons([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        const data = await seasonsService.getSeasonsByTournament(tournamentId);
        setSeasons(data);
      } catch (err) {
        setError('Error fetching seasons');
        console.error('Error in useSeasonsByTournament:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSeasons();
  }, [tournamentId]);

  return { seasons, loading, error };
};
